export default {
    index:{
        iconav1:'高端理财',
        iconav2:'推荐好友',
        iconav3:'新发产品',
        iconav4:'新手礼包',
        iconav5:'安全保障',
        iconav6:'团队奖励',
        iconav7:'每日签到',
        iconav8:'关于我们',

        hottitle:'王牌理财热销榜',
        weekrhot:'本周热销',
        buybtn : '去抢购',
        rate : '近一年收益',

        yjtitle : '稳键优选',
        dqtitle : '短期理财',
        sytitle : '收益领先',

        sstitle : '平台安全运营',
        day : '天',
        yy : '元',
        wp : '人',
        safe_desc1 : '稳键运营',
        safe_desc2 : '交易金额',
        safe_desc3 : '服务用户数',

    },
    error:{
        error_400 : '服务器错误',
        error_401 : '登录超时，请重新登录！',
        error_1001 : '参数无效',
        error_1002 : '参数为空',
        error_1003 : '参数类型错误',
        error_1004 : '参数缺失',
        error_2001 : '用户未登录',
        error_2002 : '账号不存在或密码错误',
        error_2003 : '账号已被禁用',
        error_2004 : '用户不存在',
        error_2005 : '用户已存在',
        error_3001 : '创建失败',
        error_4001 : '系统繁忙，请稍后重试',
        error_5001 : '数据未找到',
        error_5002 : '数据有误',
        error_5003 : '数据已存在',
        error_6004 : '接口地址无效',
        error_6005 : '接口请求超时',
    },
    login:{
        phone : '手机',
        Forget : '忘记密码',
        Reg   : '新用户注册',
        login  : '登陆',
        agreement  : '登陆代表已阅读并同意《服务协议》《隐私协议》',
        password : '密码',
        phone_msg: '请输入手机号码',
        pass_msg: '请输入密码'
    },
    reg:{
        reg : "注册",
        sendsms: "发送验证码",
        agreement: "注册代表已阅读并同意《服务协议》《隐私协议》",
        repassword : '确认密码',
        sms:"短信验证码",
        sms_msg : "请输入短信验证码",
        vaildphone:"请输入正确手机号码",
        reppass:"两次密码不一致",
        vading : "验证中……",
        sendok : "发送成功",
        sendfail: "发送失败",
        sendphone:"手机号码已注册",
        sendvaid: "请输入以上内容再发送验证码"


    },
    forget:{
        btnedit:"修改密码",
        pagetitle:"找回密码",
        submitok:"修改成功",
        submitfail: "修改失败"
    },
    details:{
        pagetitle: '产品详情',
        qryear : '七日年化率',
        qx:'项目期限',
        lilu:'利率',
        etitle: '基础信息',
        proname: '项目全称',
        pronano: '项目代码',
        prorisk: '项目类型',
        protime: '成立日期',
        proscale: '项目规模',
        start_threshold: '起投金额',
        term: '项目期限',
        is_repeat: '可否复投',
        insurance: '项目保险',
        dettitle: '详细信息',
        buyMoney: '购买金额',
        buyMsg: '请输入购买金额',
        buy: '立即购买',
        buyok: '购买成功',
        buyfail: '购买失败',
    },
    prolist:{
        pagetitle: '稳健理财',
        mintitle : '精选推荐',
        comment : '点评',
        m1title : '短期理财',
        m2title : '稳键优选',
        m3title : '收益领先',
    },
    me:{
        amount: "余额",
        frozen: "冻结金额",
        icotitle1: "充值",
        icotitle2: "提现",
        icotitle3: "在线客服",
        icotitle4: "财务明细",
        icotitle5: "消息",
        linktitle1: "个人信息",
        linktitle2: "我的投资",
        linktitle3: "推荐好友",
        linktitle4: "我的信息",
        linktitle5: "下载APP",
        linktitle6: "语言切换",
        linktitle7: "代理中心",
        logout : "退出登录",
        jstitle : '退出',
        jscom  : '您确让退出登录？'
    },
    userinfo:{
        username:'用户名',
        name:'姓名',
        rename: '真实姓名',
        moneyAddr : '收款地址',
        moneyStr : '钱包地址',
        tj   : '提交',
        avatar : '头像',
        pagetitle : '个人信息',
        user_tips : '请填写用户名',
        mobile_tips : "请填写手机",
        name_tips : '请填写真实姓名',
        money_tips : '请填写正确的收款地址',
        update_tips : '未修改任何资料',
        format_tips : '请上传 jpg或gif或png 格式图片',
        size_tips : '图片不能大于3M'
    },
    recharge:{
        chargetype: '充值类型',
        usdt: 'USDT充值',
        ylcharge: '银联充值',
        czmoney: '充值金额',
        inmoney: '请输入金额',
        rinmoney: '请输入正确金额',
        tips_title: '注意事项',
        charge_tips: '提交完充值，需要等待一段时间，我们会及时处理！如果没有及时到账，请联系客服！',
    },
    withdrawal : {
        pagetitle : '提现',
        txmoney : '提现金额',
        tx_info : '提交完充值，需要等待一段时间，我们会及时处理！如果没有及时到账，请联系客服！',
        tx_ok : '提现成功',

    },
    financial : {
        pagetitle : '财务明细',
        tabtitle1 : '全部',
        tabtitle2 : '充值',
        tabtitle3 : '提现',
        tabtitle4 : '投资',
        tabtitle5 : '赠送',
        tabtitle6 : '收益',
        noMore : '没有更多了',
        updatedata : '更新了{count}条数据'
    },
    my_investment : {
        pagetitle : '我的投资'
    },
    share : {
        pagetitle : '分享好友',
        nanoid : '我的推荐码',
        myfriend : '我推荐的好友',
        levelfriend : '第{value}层会员',
    },
    message :{
        pagetitle : '我的信息',
        tabtitle1 : '全部消息',
        tabtitle2 : '系统消息',
        tabtitle3 : '平台通知',
        loading : '加载中...'
    },
    app_down : {
        pagetitle : 'app下载',
    },
    system :{
        back : '返回',
        project : "项目",
        home : '首页',
        kefu : '联系',
        me : '我的',
        lang: '切换语言'
    },
    recommend:{
        noContent : '暂无内容',
        newProject : '最新产品'
    }
}
